/**
 * ACHILLES Description Cleaner & Widget Styler
 * - Removes emojis
 * - Converts ALL CAPS to sentence case
 * - Creates clean paragraphs
 * - No big headings, just normal text
 * - Removes separator blocks
 * - Styles Sympl widget to match brand
 */
(function() {
  'use strict';

  // Style Sympl widget to match Achilles brand
  function styleSymplWidget() {
    var symplWidgets = document.querySelectorAll('sympl-widget');

    symplWidgets.forEach(function(widget) {
      if (widget.shadowRoot && !widget.dataset.styled) {
        var style = document.createElement('style');
        style.textContent = `
          /* ACHILLES Brand Override - Compact Sympl Widget */
          .sympl-widget {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important;
            border: 1px solid #e8e8e8 !important;
            border-radius: 6px !important;
            background: #fafafa !important;
            padding: 10px 14px !important;
            max-height: none !important;
            min-height: auto !important;
            column-gap: 10px !important;
          }

          .sympl-widget .paragraph {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important;
            font-size: 12px !important;
            line-height: 1.4 !important;
            color: #555 !important;
          }

          .sympl-widget .paragraph > div {
            display: inline !important;
          }

          .sympl-widget .paragraph div:first-child::after {
            content: ' ' !important;
          }

          /* Price - bold black */
          .sympl-widget .color-primary,
          .sympl-widget #price {
            color: #000 !important;
            font-weight: 600 !important;
            font-size: 12px !important;
          }

          /* Strong text */
          .sympl-widget .strong {
            font-weight: 500 !important;
            color: #333 !important;
          }

          /* Learn more link - subtle */
          .sympl-widget a,
          .sympl-widget #learn-more {
            color: #666 !important;
            text-decoration: underline !important;
            text-underline-offset: 2px !important;
            font-weight: 400 !important;
            font-size: 11px !important;
          }

          .sympl-widget a:hover {
            color: #000 !important;
          }

          /* Hide hint text for cleaner look */
          .sympl-widget .hint {
            display: none !important;
          }

          /* Logo - smaller */
          .sympl-widget img {
            width: 45px !important;
            opacity: 0.8;
          }

          /* Hide offer stamp */
          .sympl-widget #offer-stamp {
            display: none !important;
          }

          /* Mobile */
          @media screen and (max-width: 480px) {
            .sympl-widget {
              padding: 8px 12px !important;
            }

            .sympl-widget .paragraph {
              font-size: 11px !important;
            }

            .sympl-widget img {
              width: 40px !important;
            }
          }
        `;
        widget.shadowRoot.appendChild(style);

        // Shorten the text content
        var paragraph = widget.shadowRoot.querySelector('.sympl-widget .paragraph');
        if (paragraph && !widget.dataset.textChanged) {
          var priceEl = paragraph.querySelector('#price');
          var priceText = priceEl ? priceEl.outerHTML : '';

          paragraph.innerHTML = `
            <div style="display:inline;">
              Split into 5 payments of ${priceText}
            </div>
            <div style="display:inline;">
              <span class="strong">0 interest. 0 registration.</span>
              <a id="learn-more" style="margin-left:4px;">learn more.</a>
            </div>
          `;
          widget.dataset.textChanged = 'true';
        }

        widget.dataset.styled = 'true';
      }
    });

    // Also style the modal popup
    var symplDialog = document.querySelector('#sympl-dialog');
    if (symplDialog && symplDialog.shadowRoot && !symplDialog.dataset.styled) {
      var modalStyle = document.createElement('style');
      modalStyle.textContent = `
        /* ACHILLES Brand Override for Sympl Modal */
        .modal-container {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important;
          border-radius: 12px !important;
          max-width: 700px !important;
        }

        .modal-header p.modal-header {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 16px !important;
          font-weight: 400 !important;
          color: #333 !important;
        }

        .modal-header .color-primary {
          color: #000 !important;
          font-weight: 600 !important;
        }

        .modal-content h3 {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 16px !important;
          font-weight: 600 !important;
          color: #000 !important;
        }

        .modal-content .steps .step p {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important;
          font-size: 13px !important;
          color: #333 !important;
        }

        /* Plan figure styling */
        .plan .color-primary,
        .plan #down-payment,
        .plan #installment {
          color: #000 !important;
        }

        .plan .plan-text {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important;
          color: #333 !important;
        }

        /* Pie charts - use black instead of pink */
        .plan .pie {
          background-color: #000 !important;
        }

        .plan .pie.twenty {
          background-image: linear-gradient(162deg, transparent 50%, white 50%), linear-gradient(90deg, white 50%, transparent 50%) !important;
        }

        .plan .pie.fourty {
          background-image: linear-gradient(234deg, transparent 50%, white 50%), linear-gradient(90deg, white 50%, transparent 50%) !important;
        }

        .plan .pie.sixty {
          background-image: linear-gradient(126deg, transparent 50%, #000 50%), linear-gradient(90deg, white 50%, transparent 50%) !important;
        }

        .plan .pie.eighty {
          background-image: linear-gradient(198deg, transparent 50%, #000 50%), linear-gradient(90deg, white 50%, transparent 50%) !important;
        }

        .plan .pie.onehundred {
          background-image: none !important;
        }

        /* Continue shopping link */
        .modal-actions h3 a {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important;
          color: #000 !important;
          font-weight: 500 !important;
          font-size: 14px !important;
        }

        /* Close button */
        .modal-close {
          color: #000 !important;
          font-size: 18px !important;
          font-weight: 400 !important;
        }

        /* Hide offer banner in modal */
        #modal-offer {
          display: none !important;
        }
      `;
      symplDialog.shadowRoot.appendChild(modalStyle);
      symplDialog.dataset.styled = 'true';
    }
  }

  // Remove separator blocks from the DOM
  function removeSeparators() {
    // Remove all hr elements in product section
    document.querySelectorAll('.product-section hr, .product-single__meta hr').forEach(function(hr) {
      hr.remove();
    });

    // Remove product blocks that only contain hr
    document.querySelectorAll('.product-block').forEach(function(block) {
      var hasOnlyHr = block.children.length === 1 && block.children[0].tagName === 'HR';
      var isEmpty = block.textContent.trim() === '' && block.querySelectorAll('img, input, button, select, svg').length === 0;

      if (hasOnlyHr || isEmpty) {
        block.remove();
      }
    });
  }

  function cleanDescriptions() {
    var containers = document.querySelectorAll('.collapsible-content__inner.rte, .product-single__description .rte');

    containers.forEach(function(container) {
      if (container.dataset.cleaned) return;

      var text = container.textContent.trim();

      // Skip if too short
      if (text.length < 50) return;

      // Check if text is mostly uppercase
      var upperCount = (text.match(/[A-Z]/g) || []).length;
      var letterCount = (text.match(/[A-Za-z]/g) || []).length;
      var isAllCaps = letterCount > 0 && (upperCount / letterCount) > 0.6;

      if (isAllCaps) {
        // Clean and format the text
        var cleaned = formatText(text);
        container.innerHTML = cleaned;
        container.dataset.cleaned = 'true';
      } else {
        // Just remove emojis
        container.innerHTML = removeEmojis(container.innerHTML);
        container.dataset.cleaned = 'true';
      }
    });
  }

  function removeEmojis(str) {
    return str.replace(/[\u{1F300}-\u{1F9FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{FE00}-\u{FE0F}]|[\u{1F000}-\u{1F02F}]|[\u{1F0A0}-\u{1F0FF}]|[\u{200D}]|[✨🔥💫⭐️👟🎯💎✓✔️⚡️🌟💪🏻👌🏻❤️🖤💯🔷🔹▪️•●◆]/gu, '').trim();
  }

  function formatText(text) {
    // Remove emojis
    text = removeEmojis(text);

    // Convert to sentence case
    text = text.toLowerCase();

    // Split into sections
    var sections = [];

    // Check for title pattern (ACHILLES | PRODUCT NAME or similar)
    var titleMatch = text.match(/^(achilles\s*[\|—–-]\s*[^.]+)/i);
    var mainText = text;

    if (titleMatch) {
      var title = capitalizeWords(titleMatch[1].trim());
      sections.push('<p><strong>' + title + '</strong></p>');
      mainText = text.substring(titleMatch[0].length).trim();
    }

    // Remove "key features:" and "styling tips:" headers - just keep the content
    mainText = mainText.replace(/key\s*features\s*:?\s*/gi, '');
    mainText = mainText.replace(/styling\s*tips\s*:?\s*/gi, '');
    mainText = mainText.replace(/details\s*:?\s*/gi, '');

    // Split into sentences and group into paragraphs
    var sentences = mainText.match(/[^.!?]+[.!?]+/g) || [mainText];
    var currentPara = '';
    var paraCount = 0;

    sentences.forEach(function(sentence) {
      sentence = sentence.trim();
      if (!sentence) return;

      // Capitalize first letter
      sentence = sentence.charAt(0).toUpperCase() + sentence.slice(1);

      // Capitalize "Achilles" brand
      sentence = sentence.replace(/\bachilles\b/gi, 'Achilles');

      currentPara += sentence + ' ';

      // Create new paragraph every 2-3 sentences or if long enough
      if (currentPara.length > 180 || (paraCount === 0 && currentPara.length > 120)) {
        sections.push('<p>' + currentPara.trim() + '</p>');
        currentPara = '';
        paraCount++;
      }
    });

    // Add remaining text
    if (currentPara.trim()) {
      sections.push('<p>' + currentPara.trim() + '</p>');
    }

    return sections.join('\n');
  }

  function capitalizeWords(str) {
    return str.replace(/\b\w/g, function(char) {
      return char.toUpperCase();
    });
  }

  // Enhance Add to Cart button with success animation
  function enhanceATCButton() {
    // Listen for successful add to cart
    document.addEventListener('ajaxProduct:added', function(e) {
      var atcButtons = document.querySelectorAll('.add-to-cart, [data-add-to-cart]');

      atcButtons.forEach(function(btn) {
        // Skip if already showing success
        if (btn.classList.contains('btn--success')) return;

        // Store original text
        var textEl = btn.querySelector('[data-add-to-cart-text]') || btn;
        var originalText = textEl.textContent;

        // Show success state
        btn.classList.remove('btn--loading');
        btn.classList.add('btn--success');
        textEl.textContent = 'Added to Bag';

        // Reset after delay
        setTimeout(function() {
          btn.classList.remove('btn--success');
          textEl.textContent = originalText;
        }, 2000);
      });
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      removeSeparators();
      cleanDescriptions();
      enhanceATCButton();
      // Style Sympl widget after a delay to ensure it's loaded
      setTimeout(styleSymplWidget, 500);
      setTimeout(styleSymplWidget, 1500);
    });
  } else {
    removeSeparators();
    cleanDescriptions();
    enhanceATCButton();
    setTimeout(styleSymplWidget, 500);
    setTimeout(styleSymplWidget, 1500);
  }

  // Run when accordion opens
  document.addEventListener('click', function(e) {
    if (e.target.closest('.collapsible-trigger')) {
      setTimeout(cleanDescriptions, 100);
    }
    // Re-style Sympl widget when clicking learn more (opens modal)
    if (e.target.closest('sympl-widget')) {
      setTimeout(styleSymplWidget, 300);
    }
  });

  // Watch for Sympl widget being added to DOM
  var symplObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(styleSymplWidget, 100);
      }
    });
  });

  symplObserver.observe(document.body, { childList: true, subtree: true });
})();
